import ReactDOM from 'react-dom';
import {AppContainer} from 'react-hot-loader';
import Router from 'react-router/lib/Router';
import browserHistory from 'react-router/lib/browserHistory';
import createStore from 'redux/lib/createStore';
import combineReducers from 'redux/lib/combineReducers';
import {Provider} from 'react-redux';
import * as reducers from './reducers';
import getWxConfig from './lib/weixin/getWxConfig';
import './lib/auth/token';

import './common.css';

const reducer = combineReducers({
  ...reducers
});

export const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()   // eslint-disable-line
);

const routes = {
  path: '/',
  indexRoute: {onEnter: (nextState, replace) => replace('error')},
  childRoutes: [
    {
      // 报告列表
      path: 'report-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/ReportListContainer').default);
        });
      }
    },
    {
      // 报告进度
      path: 'report-progress',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/ReportProgress/ReportProgress').default);
        });
      }
    },
    {
      // 报告列表
      path: 'sample-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/ReportListContainer').default);
        });
      }
    },
    {
      // 报告列表 臻溪谷定制页面
      path: 'sample-list-zxg',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/ReportListContainerZxg').default);
        });
      }
    },
    {
      // 条形码-扫码绑定
      path: 'sample-binding',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/ScanCode/ScanCode').default);
        });
      }
    },
    {
      // 绑定成功
      path: 'binding-success',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/BindingSuccess/BindingSuccess').default);
        });
      }
    },
    {
      // 绑定成功
      path: 'v2-binding-success',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/BindingSuccess/BindingSuccessV2').default);
        });
      }
    },
    {
      // 重新采样
      path: 're-sampling',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReSampling/ReSampling').default);
        });
      }
    },
    {
      // 已申请重新采样
      path: 'resampling-done',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReSampling/ReSamplingDone').default);
        });
      }
    },
    {
      // 采样指导
      path: 'sampling-guide',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SamplingGuide/SamplingGuideContainer').default);
        });
      }
    },
    {
      // 采样盒已被使用
      path: 'used-box',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/BoxUsed/BoxUsedContainer').default);
        });
      }
    },
    {
      // 报告详情
      path: 'report-detail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/ReportDetailContainer').default);
        });
      }
    },
    {
      // 全基因报告
      path: 'genes-total',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/GenesTotal/GenesTotal').default);
        });
      }
    },
    // 全基因报告详情
    {
      path: 'genes-total-details',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/GenesTotal/GenesTotalDetails/GenesTotalDetails').default);
        });
      }
    },
    {
      path: 'report',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/ReportContainer').default);
        });
      }
    },
    {
      path: 'checker-info',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SamplingGuide/CheckerInfo').default);
        });
      }
    },
    {
      path: 'female-cancer',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/FemaleCancer/FemaleCancer').default);
        });
      }
    },
    {
      path: 'fat',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Fat/Fat').default);
        });
      }
    },
    {
      path: 'alcohol',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Alcohol/Alcohol').default);
        });
      }
    },
    {
      path: 'sport',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Sport/Sport').default);
        });
      }
    },
    {
      path: 'whole-genome',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/wholeGenome/wholeGenome').default);
        });
      }
    },
    {
      path: 'synthesize-genetic',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/synthesizeGenetic/synthesizeGenetic').default);
        });
      }
    },
    {
      path: 'life',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Life/Life').default);
        });
      }
    },
    {
      path: 'patch',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Patch/Patch').default);
        });
      }
    },
    {
      path: 'skin-beauty',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/SkinBeauty/SkinBeauty').default); // 美肤宝典 介绍页
        });
      }
    },
    // {
    //   path: 'cancer',
    //   getComponents(nextState, callback) {
    //     require.ensure([], require => {
    //       callback(null, require('./components/Products/Cancer/Cancer').default); // 癌症  介绍页
    //     });
    //   }
    // },
    {
      path: 'test-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Patch/TestItem').default);
        });
      }
    },
    {
      path: 'test-process',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/TestProcess/TestProcess').default);
        });
      }
    },
    {
      path: 'enterprise-pay',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/EnterprisePay/EnterprisePay').default);
        });
      }
    },
    {
      path: 'online-pay',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/OnLinePay/OnLinePay').default);
        });
      }
    },
    {
      path: 'pay-success',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/OnLinePay/PaySuccess').default);
        });
      }
    },
    {
      path: 'test-picker',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/common/PickerDemo').default);
        });
      }
    },
    {
      path: 'store-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/ProductsStore/ProductsStore').default);
        });
      }
    },
    {
      path: 'products-store',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/ProductsStore/PStore').default);
        });
      }
    },
    {
      path: 'order-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/OrderList/OrderList').default);
        });
      }
    },
    {
      path: 'report-fat',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/FatReport/FatReport').default);
        });
      }
    },
    // 生命之光系列检测报告入口
    {
      path: 'report-life',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/LifeGeneReport/LifeGeneReport').default);
        });
      }
    },
    // 生命之康、精英人群系列检测报告入口
    {
      path: 'report-life-focus',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/LifeGeneReport/LifeGeneReportFocus').default);
        });
      }
    },
    {
      path: 'report-sport',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/SportReport/SportReport').default);
        });
      }
    },
    {
      path: 'item-detail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/SportReport/ItemDetail/ItemDetail').default);
        });
      }
    },
    {
      path: 'group-assess',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/GroupAssess/Group' +
            'Assess').default);
        });
      }
    },
    // {
    //   // 营养元素及解读能力报告
    //   path: 'report-nutrition',
    //   getComponents(nextState, callback) {
    //     require.ensure([], require => {
    //       callback(null, require('./components/ReportDetail/Nutrition/Nutrition').default);
    //     });
    //   }
    // },
    {
      // 营养元素及解读能力报告阅读说明
      path: 'nutrition-read',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/Nutrition/Read').default);
        });
      }
    },
    {
      // 营养元素详情页
      path: 'nutrition-item-details',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/Nutrition/ItemDetails').default);
        });
      }
    },
    {
      // 精英人群健康守护
      path: 'health-assess',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess' +
            '/HealthGroupAssess').default);
        });
      }
    },
    {
      path: 'item-assess',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/ItemAssess' +
            '/ItemAssess').default);
        });
      }
    },
    {
      path: 'health-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess' +
            '/HealthItemAssess').default);
        });
      }
    },
    {
      path: 'health-tumour-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess' +
            '/HealthItemAssessTumour').default);
        });
      }
    },
    {
      path: 'health-generic-tumor-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess' +
            '/HealthItemAssessGenericTumor').default);
        });
      }
    },
    {
      path: 'question-fat',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/FatReport/Questionnaire/Questionnaire').default);
        });
      }
    },
    {
      path: 'gene-detail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/Common/GeneDetail/GeneDetail').default);
        });
      }
    },
    {
      path: 'foodenergy-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/FatReport/FoodEnergyList').default);
        });
      }
    },
    {
      path: 'breast-test',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/FemaleCancer/BreastTest').default);
        });
      }
    },
    {
      path: 'life-upload',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/UploadData/UploadData').default);
        });
      }
    },
    {
      path: 'life-health',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/Health').default);
        });
      }
    },
    {
      path: 'life-consult',    // 临时测试咨询页面 之后作为组件接入生命之光报告首页后删 zgf
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Consult/Consult').default);
        });
      }
    },
    {
      path: 'life-single-test',    // 单项检测详情页面 zgf
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/SingleTest/SingleTest').default);
        });
      }
    },
    {
      // 档案 原图识别
      path: 'life-identify-result',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyResults').default);
        });
      }
    },
    {
      // 档案 原图识别失败
      path: 'life-identify-fail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyFail').default);
        });
      }
    },
    {
      // 体检结果列表
      path: 'life-group',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/HealthGroup/HealthGroup').default);
        });
      }
    },
    {
      // 档案识别状态 zgf
      path: 'life-identify-status',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyStatus').default);
        });
      }
    },
    {
      // 健康 产品列表
      path: 'health-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(
            null,
            require('./components/ReportDetail/LightOfLife/Record/BaseReport/AllAssess/AllAssess').default
          );
        });
      }
    },
    {
      // 生命认知度
      path: 'life-cognition',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(
            null,
            require('./components/Products/LifeCognition/LifeCognition').default
          );
        });
      }
    },
    {
      path: 'fill-info',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/FillInfo/FillInfo').default);
        });
      }
    },
    {
      path: 'v2-fill-info',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/FillInfo/FillInfoV2').default);
        });
      }
    },
    {
      path: 'mail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/Mail/Mail').default);
        });
      }
    },
    {
      path: 'mail-info',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/Mail/MailInfo').default);
        });
      }
    },
    {
      path: 'user-protocol',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/userProtocol/userProtocol').default);
        });
      }
    },
    {
      path: 'generic-disease',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/GenericDisease/GenericDisease').default);
        });
      }
    },
    {
      path: 'sample-active',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/SampleActive/SampleActive').default);
        });
      }
    },
    {
      path: 'sample-binding-qr', // 微信二维码绑定入口
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/WXCode/WXCode').default);
        });
      }
    },
    {
      path: 'v2-sample-binding', // 微信二维码绑定入口v2
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/WXCode/WXCodeV2').default);
        });
      }
    },
    {
      path: 'unbind', // 微信二维码绑定已被其他账号绑定
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/BindingFail/UnBind').default);
        });
      }
    },
    {
      path: 'binding-fail', // 微信二维码绑定失败入口
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/SampleBinding/BindingFail/BindingFail').default);
        });
      }
    },
    {
      path: 'pre-pregnancy',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/PrePregnancy/PrePregnancy').default);
        });
      }
    },
    {
      path: 'pre-pre-table',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/PrePregnancy/PPTable').default);
        });
      }
    },
    {
      path: 'alcohol-item-details', // 酒精报告相关项目详情
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/AlcoholReport/ItemDetails/ItemDetails').default);
        });
      }
    },
    {
      path: 'mouth-shidao',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/SDCancer/SDCancer').default);
        });
      }
    },
    {
      path: 'glonoin',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Glonoin/Glonoin').default);
        });
      }
    },
    {
      path: 'health-answer', // 生命之光报告问卷答案
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/Answers/Answers').default);
        });
      }
    },
    {
      // 体检结果列表
      path: 'experience-abnormal',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/HealthGroup/ExperAbnormal').default);
        });
      }
    },
    {
      path: 'life-ques', // 生命之光问卷
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Questionnaire/Questionnaire').default);
        });
      }
    },
    {
      path: 'life-ques-skip', // 生命之光问卷跳过
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Questionnaire/Skip').default);
        });
      }
    },
    {
      path: 'bcy-health-protection', // 精准健康基因检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/BCYHealthProtection/BCYHealthProtection').default);
        });
      }
    },
    {
      path: 'health-protection', // 精准健康基因检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/HealthProtection/HealthProtection').default);
        });
      }
    },
    {
      path: 'bcy-accurate-gene', // 百草园精准健康入口
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/AccurateGene/AccurateGene').default);
        });
      }
    },
    {
      path: 'life-bank', // 精准健康基因检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LifeBank/LifeBank').default);
        });
      }
    },
    {
      path: 'patch-item-details', // 补养有方报告项目详情
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/PatchReport/PatchItem/PatchItem').default);
        });
      }
    },
    {
      path: 'product-life-bank', // 补养有方报告项目详情
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/LifeBank/LifeBank').default);
        });
      }
    },
    {
      path: 'access-to-report', // 通过手机号码获取报告界面
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/AccessToReport').default);
        });
      }
    },
    {
      path: 'access-to-report-zxg', // 通过手机号码获取报告界面 臻溪谷定制页面
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/AccessToReportZxg').default);
        });
      }
    },
    {
      path: 'life-fu', // 生命之福
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/LifeSeries/LifeFu/LifeFu').default);
        });
      }
    },
    {
      path: 'life-le', // 生命之乐
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/LifeSeries/LifeLe/LifeLe').default);
        });
      }
    },
    {
      path: 'life-kang', // 生命之康
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/LifeSeries/LifeKang/LifeKang').default);
        });
      }
    },
    {
      path: 'life-an', // 生命之安
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/LifeSeries/LifeAn/LifeAn').default);
        });
      }
    },
    {
      path: 'children', // 儿童安全用药
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Children/Children').default);
        });
      }
    },
    {
      path: 'children-item', // 儿童安全用药详情
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Children/ChildrenItem').default);
        });
      }
    },
    {
      path: 'Adult', // 成人安全用药
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Adult/Adult').default);
        });
      }
    },
    {
      path: 'familiar-tumor', // 常见肿瘤易感基因检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/FamiliarTumor/FamiliarTumor').default);
        });
      }
    },
    {
      path: 'tumour-medicine', // 肿瘤药物检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Tumour/TumourMedicine/TumourMedicine').default);
        });
      }
    },
    {
      path: 'tumour-relapse', // 肿瘤复发检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Tumour/TumourRelapse/TumourRelapse').default);
        });
      }
    },
    {
      path: 'tumour-family', // 肿瘤家族遗传检测
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Tumour/TumorFamilyGenetic/TumorFamilyGenetic').default);
        });
      }
    },
    { // 爱康国宾登陆页面
      path: 'ikang-login',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport' +
            '/IKangLogin').default);
        });
      }
    },
    { // 爱康国宾一般检查项
      path: 'general-test',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport' +
            '/GeneralTest').default);
        });
      }
    },
    { // 爱康国宾其他检查项
      path: 'other-test',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport' +
            '/OtherTest').default);
        });
      }
    },
    { // 爱康国宾体检报告界面
      path: 'ikang-report',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport' +
            '/IKangReport').default);
        });
      }
    },
    { // 瑞慈登陆页面
      path: 'ruici-login',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport' +
            '/RuiCIReport/RuiCiLogin').default);
        });
      }
    },
    { // 体检报告综合建议界面
      path: 'report-suggest',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport' +
            '/ReportSuggest').default);
        });
      }
    },
    { // 图片报告界面
      path: 'photo-report',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/Medica' +
            'lReport/PhotoReport').default);
        });
      }
    },
    { // 综合体检建议
      path: 'test-advise',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdvise').default);
        });
      }
    },
    { // 综合体检建议单项
      path: 'test-advise-item',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdviseItem').default);
        });
      }
    },
    { // 问卷参考知识
      path: 'reference-knowledge',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/Questionnaire/ReferenceKnowledge').default);
        });
      }
    },
    {
      // 短信－导航首页-索真健康
      path: 'guide-page2',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/MessageGuideHome').default);
        });
      }
    },
    {
      // 短信－导航页-索真慧康
      path: 'guide-page',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/MessageGuidePage').default);
        });
      }
    },
    {
      // 短信－导航页-索真健康
      path: 'guide-home',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportList/MessageGuidePageNew').default);
        });
      }
    },
    {
      // 生命银行新路由
      path: 'life-bank-home',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/LifeReport').default);
        });
      }
    },
    {
      // 生命银行新路由
      path: 'has-life',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/HasLifeReport/HasLifeReport').default);
        });
      }
    },
    {
      // 健康建议路由
      path: 'health-advice',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/LightOfLife/LifeGeneReport/HealthAdvice' +
            '/HealthAdvice').default);
        });
      }
    },
    {
      // 精准健康基因体检
      path: 'accurate-health',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/AccurateHealth/AccurateHealth').default);
        });
      }
    },
    {
      // 404
      path: 'error',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/common/Error/Error').default);
        });
      }
    },
    {
      path: 'xnxg',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Xnxg/Xnxg').default);
        });
      }
    },
    {
      path: 'tumor-gene',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/TumorGene/TumorGene').default);
        });
      }
    },
    {
      path: 'genetic-testing',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/GeneticTesting/GeneticTesting').default);
        });
      }
    },
    // 2019-03-01 妇女节活动添加体检套餐内容展示页面 ch
    {
      path: 'activity',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Activity/activity').default);
        });
      }
    },
    // 2019-05-05 招商活动H5页面 ch
    {
      path: 'partner',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Products/Activity/partner').default);
        });
      }
    },
    // 2020-04-29 疲劳度测试
    {
      path: 'Questionnaire',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/Questionnaire/Questionnaire').default);
        });
      }
    },
    // 核酸检测线上预约（个人预约）
    {
      path: 'nucleic-acid-appointment',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcidPersonal/NucleicAcid').default);
        });
      }
    },
    // 核酸检测线上预约列表（个人预约）
    {
      path: 'nucleic-acid-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcidPersonal/AppointmentList').default);
        });
      }
    },
    // 核酸检测线上预约（现场绑定）
    {
      path: 'ncov-check',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/NucleicAcid').default);
        });
      }
    },
    // 核酸检测线上预约列表（现场绑定）
    {
      path: 'ncov-check-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/AppointmentList').default);
        });
      }
    },
    // 核酸检测线上预约（现场绑定新版本）
    {
      path: 'ncov-check-new',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/NucleicAcidV2').default);
        });
      }
    },
    // 核酸检测线上预约列表（现场绑定新版本）
    {
      path: 'ncov-check-list-new',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/AppointmentListV2').default);
        });
      }
    },
    // 核酸检测线上预约列表（现场绑定新版本）
    {
      path: 'invoice-submit',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/AppointmentListV2').default);
        });
      }
    },
    // 核酸检测线上预约发票信息录入（现场绑定）
    {
      path: 'ncov-invoice-entry',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoiceEntry').default);
        });
      }
    },
    {
      path: 'ncov-invoice',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoice').default);
        });
      }
    },
    {
      path: 'ncov-invoice-entry-new',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoiceEntryV2').default);
        });
      }
    },
    {
      path: 'ncov-invoice-new',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoiceV2').default);
        });
      }
    },
    {
      path: 'report-ncov',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/NucleicAcid/NucleicAcid').default);
        });
      }
    },
    {
      path: 'report-ncov-share',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/ReportDetail/NucleicAcid/ShareReport').default);
        });
      }
    },
    // 核酸检测线上支付流程 详情页
    {
      path: 'ncov-register-details',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/registerDetails').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付页
    {
      path: 'ncov-register-pay',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/registerPay').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付页采样点列表
    {
      path: 'ncov-register-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/registerPlaceList').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝支付引导页
    {
      path: 'ncov-alipay-guide',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/alipayGuide').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝返回结果页
    {
      path: 'ncov-alipay-success',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/ncovAlipaySuccess').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝返回结果页
    // TODO: 配置路由 多个
    {
      path: 'ncov-order-user-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/orderUserList').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝返回结果页
    {
      path: 'ncov-order-user-register',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/orderUserRegister').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝返回结果页
    {
      path: 'ncov-order-user-check',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/orderUserCheck').default);
        });
      }
    },
    // 核酸检测线上支付流程 支付宝返回结果页
    {
      path: 'ncov-order-place-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/orderUserPlaceList').default);
        });
      }
    },
    // 发票状态 页面
    {
      path: 'ncov-invoice-status',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoiceStatusV2').default);
        });
      }
    },
    {
      path: 'ncov-invoice-img',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/invoiceViewV2').default);
        });
      }
    },
    // 个人预约详情页
    {
      path: 'ncov-single-reserve',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/singleRegisterDetails').default);
        });
      }
    },
    // 个人预约选择日期采样点页面
    // {
    //   path: 'ncov-check-date',
    //   getComponents(nextState, callback) {
    //     require.ensure([], require => {
    //       callback(null, require('./components/NucleicAcid/NucleicAcidPlaceTimeV2').default);
    //     });
    //   }
    // },
    // 个人预约采样点列表
    // {
    //   path: 'ncov-check-place-list',
    //   getComponents(nextState, callback) {
    //     require.ensure([], require => {
    //       callback(null, require('./components/NucleicAcid/NucleicAcidPlaceListV2').default);
    //     });
    //   }
    // },
    // 核酸检测线上支付流程 支付宝支付引导页（团体预约自费）
    {
      path: 'ncov-alipay-guide-order',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/orderAlipayGuide').default);
        });
      }
    },
    // 核酸检测 查询采样信息
    {
      path: 'ncov-sample-info-query',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleInfoQueryV2').default);
        });
      }
    },
    // 核酸检测 查询采样信息结果
    {
      path: 'ncov-sample-info-queryResults',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleInfoQueryResultsV2').default);
        });
      }
    },
    // 核酸检测 查询采样信息
    {
      path: 'ncov-sample-info-queryCourse',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleInfoQueryCourseV2').default);
        });
      }
    },
    // 核酸检测 进度查询
    {
      path: 'ncov-sample-info-progress',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleInfoProgressV2').default);
        });
      }
    },
    // 核酸检测 进度查询失败详情填写查询页面
    {
      path: 'ncov-sample-appear-progress',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleAppearProgressV2').default);
        });
      }
    },
    // 核酸检测 进度查询失败详情查询结果页面
    {
      path: 'ncov-sample-appear-result',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleAppearRresultV2').default);
        });
      }
    },
    // 核酸检测 进度查询首页判断用户是否关注公众号 未关注，海报页
    {
      path: 'ncov-sample-appear-followAccounts',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/sampleFollowAccountsV2').default);
        });
      }
    },
    // 检测保单列表
    {
      path: 'ncov-guarantee-slip-list',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/guaranteeSlipListV2').default);
        });
      }
    },
    // 完善保单人信息
    {
      path: 'ncov-guarantee-slip-fill',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/guaranteeSlipFillV2').default);
        });
      }
    },
    // 保单人详情
    {
      path: 'ncov-guarantee-slip-detail',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/guaranteeSlipDetailV2').default);
        });
      }
    },
    // 保单人扫描报告二维码判断过渡页面
    {
      path: 'ncov-guarantee-slip-transition',
      getComponents(nextState, callback) {
        require.ensure([], require => {
          callback(null, require('./components/NucleicAcid/guaranteeSlipTransitionV2').default);
        });
      }
    }
  ]
};

ReactDOM.render(
  <AppContainer>
    <Provider store={store}>
      <Router history={browserHistory} routes={routes}/>
    </Provider>
  </AppContainer>,
  document.getElementById('approot')
);

getWxConfig();

if (process.env.NODE_ENV === 'dev') {
  /* eslint-disable */
  if (module.hot) {
    module.hot.accept(
      [
        // './components/ReportList/ReportListContainer',
        './components/ReportList/ReportProgress/ReportProgress', // 报告进度
        './components/SampleListNew/SampleListContainer',
        './components/SampleBinding/ScanCode/ScanCode',
        './components/SampleBinding/FillInfo/FillInfo',
        './components/ReSampling/ReSampling',
        './components/ReSampling/ReSamplingDone',
        './components/SamplingGuide/SamplingGuideContainer',
        './components/BoxUsed/BoxUsedContainer',
        './components/ReportDetail/ReportDetailContainer',
        './components/ReportDetail/GenesTotal/GenesTotal',
        './components/ReportDetail/GenesTotal/GenesTotalDetails/GenesTotalDetails',
        './components/ReportDetail/ReportContainer',
        './components/SamplingGuide/CheckerInfo',
        './components/Products/TestProcess/TestProcess',
        './components/Products/FemaleCancer/FemaleCancer',
        './components/Products/Fat/Fat',
        './components/EnterprisePay/EnterprisePay',
        './components/OnLinePay/OnLinePay',
        './components/OnLinePay/PaySuccess',
        './components/Products/Alcohol/Alcohol',
        './components/Products/Sport/Sport',
        './components/Products/GenericDisease/GenericDisease', // 遗传病
        './components/Products/Life/Life',
        './components/Products/Patch/Patch',
        './components/Products/Patch/TestItem',
        './components/Products/SkinBeauty/SkinBeauty', //美肤宝典 介绍页
        // './components/Products/Cancer/Cancer', //癌症 介绍页
        './components/common/PickerDemo',
        './components/Products/ProductsStore/ProductsStore',
        './components/Products/ProductsStore/PStore',
        './components/OrderList/OrderList',
        './components/ReportDetail/FatReport/FatReport',
        './components/ReportDetail/LightOfLife/LifeReport',
        './components/ReportDetail/SportReport/SportReport',
        './components/ReportDetail/Nutrition/Nutrition',
        './components/ReportDetail/SportReport/ItemDetail/ItemDetail',
        './components/ReportDetail/LightOfLife/Record/BaseReport/GroupAssess/GroupAssess',
        './components/ReportDetail/LightOfLife/Record/BaseReport/ItemAssess/ItemAssess',
        './components/ReportDetail/FatReport/Questionnaire/Questionnaire',
        './components/ReportDetail/Common/GeneDetail/GeneDetail',
        './components/ReportDetail/FatReport/FoodEnergyList',
        './components/Products/FemaleCancer/BreastTest',
        './components/ReportDetail/LightOfLife/Health/UploadData/UploadData',
        './components/ReportDetail/LightOfLife/Health/Health',
        './components/ReportDetail/LightOfLife/Consult/Consult', // 临时测试咨询页面 之后作为组件接入生命之光报告首页后删 zgf
        './components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyResults',
        './components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyFail',
        './components/ReportDetail/LightOfLife/Health/SingleTest/SingleTest',  // 单项检测详情页面 zgf
        './components/ReportDetail/LightOfLife/Health/HealthGroup/HealthGroup',
        './components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyStatus', // 档案识别状态 zgf
        './components/ReportDetail/LightOfLife/Record/BaseReport/AllAssess/AllAssess',  // 健康 产品列表 zc
        './components/SampleBinding/BindingSuccess/BindingSuccess', // 绑定成功
        './components/SampleBinding/BindingSuccess/BindingSuccessV2', // 绑定成功
        './components/Products/LifeCognition/LifeCognition',
        './components/SampleBinding/SampleActive/SampleActive', // 激活套件
        './components/SampleBinding/WXCode/WXCode', // 微信二维码绑定入口
        './components/SampleBinding/BindingFail/BindingFail',
        './components/ReportDetail/AlcoholReport/ItemDetails/ItemDetails', // 酒精报告相关项目详情
        './components/SampleBinding/BindingFail/BindingFail',
        './components/Products/PrePregnancy/PrePregnancy', // 孕前检查
        './components/Products/PrePregnancy/PPTable',
        './components/Products/SDCancer/SDCancer', // 食道癌
        './components/Products/Glonoin/Glonoin',
        './components/ReportDetail/LightOfLife/Health/Answers/Answers', // 生命之光报告问卷答案
        './components/ReportDetail/LightOfLife/Health/HealthGroup/ExperAbnormal',
        './components/ReportDetail/LightOfLife/Questionnaire/Questionnaire',
        './components/ReportDetail/LightOfLife/Questionnaire/Skip',
        './components/ReportDetail/LifeBank/LifeBank',
        './components/Products/PrePregnancy/PPTable',
        './components/ReportDetail/PatchReport/PatchItem/PatchItem',
        './components/Products/BCYHealthProtection/BCYHealthProtection',
        './components/Products/HealthProtection/HealthProtection',
        './components/Products/AccurateGene/AccurateGene',
        './components/Products/LifeBank/LifeBank',
        './components/ReportList/AccessToReport',
        './components/Products/LifeSeries/LifeFu/LifeFu',// 生命之福
        './components/Products/LifeSeries/LifeLe/LifeLe',// 生命之乐
        './components/Products/LifeSeries/LifeKang/LifeKang',// 生命之康
        './components/ReportList/AccessToReport',
        './components/Products/Tumour/TumourMedicine/TumourMedicine',  // 肿瘤药物检测
        './components/Products/Tumour/TumourRelapse/TumourRelapse', // 肿瘤复发检测
        './components/Products/Tumour/TumourMedicine/TumourMedicine',  // 肿瘤药物检测
        './components/Products/Tumour/TumorFamilyGenetic/TumorFamilyGenetic', // 肿瘤家族遗传检测
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/IKangLogin', // IKangLogin
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport/GeneralTest',
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport/OtherTest',
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/IKangReport',
        './components/ReportDetail/LightOfLife/Record/BaseReport/RuiCIReport/RuiCiLogin',
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/ReportSuggest',
        './components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport/PhotoReport',
        './components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdvise',
        './components/ReportDetail/LightOfLife/Questionnaire/ReferenceKnowledge',
        './components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdviseItem',
        './components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess/HealthGroupAssess', // 精英人群健康守护
        './components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess/HealthItemAssess',
        './components/ReportDetail/LightOfLife/LifeGeneReport/LifeGeneReport',
        './components/ReportDetail/LightOfLife/HasLifeReport/HasLifeReport',
        './components/Products/Children/ChildrenItem',
        './components/Products/AccurateHealth/AccurateHealth',
        './components/Questionnaire/Questionnaire'
      ], () => {
        // If you use Webpack 2 in ES modules mode, you can
        // use <App /> here rather than require() a <NextApp />.
        // require('./components/ReportList/ReportListContainer');
        //
        require('./components/ReportList/ReportProgress/ReportProgress'); // 报告进度
        require('./components/SampleBinding/ScanCode/ScanCode');
        require('./components/SampleBinding/FillInfo/FillInfo');
        require('./components/ReSampling/ReSampling');
        require('./components/ReSampling/ReSamplingDone');
        require('./components/SamplingGuide/SamplingGuideContainer');
        require('./components/BoxUsed/BoxUsedContainer');
        require('./components/ReportDetail/ReportDetailContainer');
        require('./components/ReportDetail/GenesTotal/GenesTotal');
        require('./components/ReportDetail/GenesTotal/GenesTotalDetails/GenesTotalDetails');
        require('./components/ReportDetail/ReportContainer');
        require('./components/SamplingGuide/CheckerInfo');
        require('./components/Products/FemaleCancer/FemaleCancer');
        require('./components/Products/Fat/Fat');
        require('./components/EnterprisePay/EnterprisePay');
        require('./components/OnLinePay/OnLinePay');
        require('./components/OnLinePay/PaySuccess');
        require('./components/Products/Alcohol/Alcohol');
        require('./components/Products/GenericDisease/GenericDisease');
        require('./components/Products/TestProcess/TestProcess');
        require('./components/Products/Sport/Sport');
        require('./components/Products/Life/Life');
        require('./components/Products/Patch/Patch');
        require('./components/Products/SkinBeauty/SkinBeauty'); //美肤宝典 介绍页
        // require('./components/Products/Cancer/Cancer'); //癌症 介绍页
        require('./components/Products/Patch/TestItem');
        require('./components/common/PickerDemo');
        require('./components/Products/ProductsStore/ProductsStore');
        require('./components/Products/ProductsStore/PStore');
        require('./components/OrderList/OrderList');
        require('./components/ReportDetail/FatReport/FatReport');
        require('./components/ReportDetail/SportReport/SportReport');
        require('./components/ReportDetail/SportReport/ItemDetail/ItemDetail');
        require('./components/ReportDetail/Nutrition/Nutrition');
        require('./components/ReportDetail/FatReport/Questionnaire/Questionnaire');
        require('./components/ReportDetail/Common/GeneDetail/GeneDetail');
        require('./components/ReportDetail/FatReport/FoodEnergyList');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/GroupAssess/GroupAssess');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/ItemAssess/ItemAssess');
        require('./components/ReportDetail/LightOfLife/LifeReport');
        require('./components/Products/FemaleCancer/BreastTest');
        require('./components/ReportDetail/LightOfLife/Health/UploadData/UploadData');
        require('./components/ReportDetail/LightOfLife/Health/Health');
        require('./components/ReportDetail/LightOfLife/Consult/Consult'); // 临时测试咨询页面 之后作为组件接入生命之光报告首页后删 zgf
        require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyResults');
        require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyFail');
        require('./components/ReportDetail/LightOfLife/Health/SingleTest/SingleTest'); // 单项检测详情页面 zgf
        require('./components/ReportDetail/LightOfLife/Health/HealthGroup/HealthGroup');
        require('./components/ReportDetail/LightOfLife/Record/HealthRecord/IdentifyStatus'); // 档案识别状态 zgf
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/AllAssess/AllAssess');  // 健康 产品列表 zc
        require('./components/Products/LifeCognition/LifeCognition');
        require('./components/SampleBinding/SampleActive/SampleActive');
        require('./components/SampleBinding/WXCode/WXCode'); // 微信二维码绑定入口
        require('./components/SampleBinding/BindingFail/BindingFail');
        require('./components/ReportDetail/AlcoholReport/ItemDetails/ItemDetails');// 酒精报告相关项目详情
        require('./components/Products/PrePregnancy/PrePregnancy'); // 孕前检查
        require('./components/Products/PrePregnancy/PPTable');
        require('./components/Products/SDCancer/SDCancer');
        require('./components/Products/Glonoin/Glonoin');
        require('./components/ReportDetail/LightOfLife/Health/Answers/Answers'); // 生命之光报告问卷答案
        require('./components/ReportDetail/LightOfLife/Health/HealthGroup/ExperAbnormal');
        require('./components/ReportDetail/LightOfLife/Questionnaire/Questionnaire');
        require('./components/ReportDetail/LightOfLife/Questionnaire/Skip');
        require('./components/ReportDetail/LifeBank/LifeBank');
        require('./components/ReportDetail/PatchReport/PatchItem/PatchItem');
        require('./components/Products/BCYHealthProtection/BCYHealthProtection');
        require('./components/Products/HealthProtection/HealthProtection');
        require('./components/Products/AccurateGene/AccurateGene');
        require('./components/Products/LifeBank/LifeBank');
        require('./components/ReportList/AccessToReport');
        require('./components/Products/LifeSeries/LifeFu/LifeFu'); // 生命之福
        require('./components/Products/LifeSeries/LifeLe/LifeLe'); // 生命之乐
        require('./components/Products/LifeSeries/LifeKang/LifeKang'); // 生命之康
        require('./components/Products/Tumour/TumourMedicine/TumourMedicine');  // 肿瘤药物检测
        require('./components/Products/Tumour/TumourRelapse/TumourRelapse');  // 肿瘤复发检测
        require('./components/Products/Tumour/TumorFamilyGenetic/TumorFamilyGenetic'); // 肿瘤家族遗传检测
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/IKangLogin');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport/GeneralTest');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport' +
          '/OtherTest');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/IKangReport');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/RuiCIReport/RuiCiLogin');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/ReportSuggest');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/IKangReport/MedicalReport/PhotoReport');
        require('./components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdvise');
        require('./components/ReportDetail/LightOfLife/Questionnaire/ReferenceKnowledge');
        require('./components/ReportDetail/LightOfLife/Health/TestAdvise/TestAdviseItem');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess/HealthGroupAssess');
        require('./components/ReportDetail/LightOfLife/Record/BaseReport/HealthGroupAssess/HealthItemAssess');
        require('./components/ReportDetail/LightOfLife/LifeGeneReport/LifeGeneReport');
        require('./components/ReportDetail/LightOfLife/HasLifeReport/HasLifeReport');
        require('./components/Products/Children/ChildrenItem');
        require('./components/Products/AccurateHealth/AccurateHealth');
        require('./components/Questionnaire/Questionnaire');
        ReactDOM.render(
          <AppContainer>
            <Provider store={store}>
              <Router history={browserHistory}>
              </Router>
            </Provider>
          </AppContainer>,
          document.getElementById('approot')
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/index.js